import apiRequest from '@libs/apiRequest';
import { call, put } from 'redux-saga/effects';
import { setLoading, setSnack } from 'utilities/redux.actions';

export default function* (action) {
    const {
        meta: { handleSubmit = () => {} },
        payload: { id, decisions, comment }
    } = action;

    yield put(setLoading(true));
    try {
        const { data } = yield call(apiRequest, {
            url: `profile-change-request/review?id=${id}`,
            method: 'post',
            data: JSON.stringify({ decisions, comment })
        });
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: `Change request ${data?.status || 'reviewed'}`,
                type: 'success'
            })
        );
        return handleSubmit(data);
    } catch (error) {
        yield put(setLoading(false));
        yield put(
            setSnack({
                message: error?.response?.data?.message || error?.message,
                type: 'error'
            })
        );
        // keep the dialog open on failure — no success callback
        return null;
    }
}
